var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevtoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(-59 -243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M4.692-8.815l-2.675.98,2.675.972v1L.868-7.313V-8.357L4.692-9.812Zm2.876-2.973H8.685L6.034-4.22H4.917Zm5.086,3.431v1.044L8.83-5.859v-1l2.675-.972L8.83-8.815v-1Z",
    transform: "translate(61.739 258.004)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    transform: "translate(59 243)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 17.2,
    height: 12.2,
    rx: 0.6,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevtoolIcon);
export default __webpack_public_path__ + "static/media/devtoolIcon.c608ffbc5d2ab3ba43a06acef8663cd7.svg";
export { ForwardRef as ReactComponent };